import React from 'react'
import styles from './styles/Home.module.css'

export default function ShowcaseFooter() {
  return (
    <footer className={styles.footer}>
      <a href='https://revart.co' target='_blank' rel='noopener noreferrer' style={{ fontSize: 10, color: 'black' }}>
        Powered by{' @RevArt '}
      </a>
    </footer>
  )
}
